//Angular References
import { Component, OnInit, ViewChild, Inject, ViewChildren, QueryList } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray, AbstractControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

//Service
import { UtilityService } from '../../../services/shared/utility.service';
import { ConfigMasterService } from '../../../services/configMaster.service';
import { UserService } from '../../../services/user.service';
import { BillingService } from '../../../services/billing.service';

//Custom Validators
import { CustomValidators } from '../../../shared/custom.validators';
import { ProductService } from '../../../services/product.service';

//Models
import { User, UserResponse } from '../../../models/user.model';
import { ConfigMaster, ConfigMasterResponse, NSIvoice, PPSOPrice, PPSOPriceResponse, UserNetSuit, UserNetSuitResponse, UserNMIKeys, UserNMIKeysResponse } from '../../../models/configMaster.model';
import { ProductListResponse, ProductDetails, ProductResponse } from '../../../models/product.model';
import { DocumentService } from '../../../services/document.service';
import { DocumentTemplateListResponse, DocumentTemplate, ConfigDocuments, ConfigDocumentsResponse, DocumentTypeResponse, DocType, Holidays, Holiday, HolidayYear } from '../../../models/document.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { WizardService } from '../../../services/wizard.service';
import { SimpleResponse } from '../../../models/genericResponse.model';
import { CheckListService } from '../../../services/checkList.service';
import { configCheckList, CheckListImagesResponse, ConfigCheckListImagesResponse } from '../../../models/checkList.model';
import { isNullOrUndefined } from 'util';
import { formatDate } from '@angular/common';
import { APRConfig, APRConfigResponse } from '../../../models/billing.model';

//For jquery
declare var $: any;

@Component({
    selector: 'app-contract-config',
    templateUrl: './contract-config.component.html',
    styleUrls: ['./contract-config.component.css']
})


export class ContractConfigComponent implements OnInit {
    IvForm: FormGroup;
    isEditableNew: boolean = true;
    currentUser: User;
    clpUserId: number = 0;
    private encryptedUser: string = '';
    isPatentPlusUser: boolean = false;
    isPromotions: boolean;
    configMaster: ConfigMaster[];
    configMasterResponse: ConfigMasterResponse;
    holidayResponse: Holiday;
    nsIvoiceResponse: NSIvoice;
    infoConfirm: string = '';
    configMasterForm: FormGroup;
    @ViewChild('aprEnd', { static: true }) aprEnd;
    ppsoPriceResponse: PPSOPriceResponse;
    userNMIKeysResponse: UserNMIKeysResponse;
    userNetSuitResponse: UserNetSuitResponse;
    ppsoPrice: PPSOPrice[] = [];
    userNMIKeyslst: UserNMIKeys[] = [];
    userNetSuitlst: UserNetSuit[] = [];
    holidaylst: Holiday[] = [];
    NSIvoicelst: NSIvoice[] = [];
    displayedColumns: string[] = ['id', 'productCode', 'paramDesc', 'paramVal'];
    displayedUSerNMIKeysColumns: string[] = ['clpUserId', 'userName', 'nmiKey'];
    displayedUSerNetSuitColumns: string[] = ['id', 'clpUserId', 'userName', 'officeName', 'officeCode', 'internalId'];
    displayedHolidayColumns: string[] = ['id', 'dtHoliday', 'holidayName', 'actions'];
    displayednsInvoiseColumns: string[] = ['id', 'internalId', 'item', 'description', 'USPrice', 'CANPrice', 'AUSPrice', 'UKPrice', 'actions'];
    dataSource = new MatTableDataSource<PPSOPrice>(this.ppsoPrice);
    userNMIKeysdataSource = new MatTableDataSource<UserNMIKeys>(this.userNMIKeyslst);
    userNetSuitdataSource = new MatTableDataSource<UserNetSuit>(this.userNetSuitlst);
    holiDayListdataSource = new MatTableDataSource<Holiday>(this.holidaylst);
    NSInvoiseListdataSource = new MatTableDataSource<any>(this.NSIvoicelst);

    selectedppso: PPSOPrice;
    selectedUserNMIKeys: UserNMIKeys;
    selectedUserNetSuit: UserNetSuit;
    editRowID: number = -1;
    editRowIDTemplate: number = -1;
    editRowIDUserNMIKeys: number = -1;
    editRowIDUserNetSuit: number = -1;

    highlightedRows = [];
    highlightedUserNMIKeysRows = [];
    highlightedUserNetSuitRows = [];
    highlightedRowsTemplate = [];

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('docTable', { read: MatSort }) sortTemplate: MatSort;
    @ViewChild('nmiTable', { read: MatSort }) sortNMI: MatSort;
    @ViewChild('netsuitTable', { read: MatSort }) sortNETSUIT: MatSort;
    @ViewChild('holidayTable', { read: MatSort }) sortHoliday: MatSort;
    @ViewChild('nsinvoiceTable', { read: MatSort }) sortNSI: MatSort;
    @ViewChild('aprConfig', { read: MatSort }) sortAPR: MatSort;

    docTypelst: DocType[] = [];
    updatedDocTypelst: DocType[] = [];
    docTemplateList: DocumentTemplate[];
    datasourceTemplate = new MatTableDataSource<DocType>(this.docTypelst);
    displayedColsForTemplate: string[] = ['documentTypeID', 'documentTypeName', 'mailMergeTemplateName', 'NewTemplate'];
    changeTemplateEvent: boolean = false;
    selectedDocumentTypeId: number = -1;
    isTemplateDirty: boolean = false;
    isAPRDirty: boolean = false;
    userResponse: UserResponse;
    displayColumnAPRConfig: string[] = ['configId', 'productDescription', 'priceRange', 'defaultRates', 'newRates', 'enterAPR'];
    aprConfigList: APRConfig[] = [];
    updatedAPRConfigList: APRConfig[] = [];
    aprDatasource = new MatTableDataSource<APRConfig>(this.aprConfigList);

    lastAddedDOCImageId: number = 0;
    private checkListImagesResponse: CheckListImagesResponse;
    private configCheckListImagesResponse: ConfigCheckListImagesResponse;
    showUploadCheckListFlg: boolean = false;
    resetUpload: boolean;
    site: string = "";
    checkListConfig: any;
    private simpleResponse: SimpleResponse;
    private globalCheckListResponse: any;
    checkList: configCheckList[];
    isNMICancel: boolean = false;
    isNetSuitCancel: boolean = false;
    yearList: HolidayYear[] = [];
    btnAdd: string = "Add";
    hldId: number = 0;
    minDate: Date;
    minAPRStartDate: Date;
    minAPREndDate: Date;
    isPreYear: boolean = true;
    delId: number;
    mySOSite: string = '';
    siteURL: string = '';
    showShortSpan: boolean;
    dtAPRStart: Date;
    dtAPREnd: Date;

    constructor(private fb: FormBuilder,
        private _formBuilder: FormBuilder,
        private _utilityService: UtilityService,
        private _router: Router,
        private _route: ActivatedRoute,
        private _configMasterService: ConfigMasterService,
        private _documentService: DocumentService,
        private _billingService: BillingService,
        private _snackBar: MatSnackBar,
        private _wizardService: WizardService,
        private _checkListService: CheckListService,
        private _userService: UserService
    ) {
        this._route.queryParamMap.subscribe(params => {
            if (params.has('r')) {
                this.encryptedUser = params.get('r');
                this._userService.getAuthenticateR(this.encryptedUser)
                    .then(res => {
                        if (res) {
                            if (res.isvalid) {
                                console.log("Valid User");
                            } else {
                                this._router.navigate(['/unauthorized']);
                            }
                        } else {
                            this._router.navigate(['/unauthorized']);
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        console.log("Client side Error : " + err);
                        this._utilityService.handleErrorResponse(err);
                    });
            }
            else {
                console.log('no r');
                this._router.navigate(['/unauthorized']);
            }
        });
        this._route.paramMap.subscribe(async params => {
            if (params.has('patentId'))
                this.isPatentPlusUser = params.get('patentId') == "1" ? true : false;
        });
        this.minDate = new Date("1/1/" + (new Date()).getFullYear());
        this.minAPRStartDate = new Date();
        this.minAPREndDate = new Date();
    }

    get form() { return this.configMasterForm.controls; }

    ngOnInit() {
        this.dataSource.sort = this.sort;

        this.configMasterForm = this.fb.group({
            isPromotions: [{ value: false }],
            totalCustomers: [{ value: 0 }],
            ndTotalCustomers: [{ value: 0 }],
            firstPASRR: [{ value: 0 }],
            holidayDate: ['', [Validators.required]],
            holidayName: ['', [Validators.required]],
            aprStartDate: [''],
            aprEndDate: [''],
            holidayYear: [''],
            lawyerReferralCost: [{ value: 0 }],
        });
        this.IvForm = this.fb.group({
            IvRows: this.fb.array([])
        });
        this.getUPNSInvoiceAsync(0);
        this.loadYear();
        this.loadConfigMaster();
        this.loadPPSOPrice();
        this.changeTemplateEvent = false;
        this.loadDocumentTypeConfigData();
        this.loadAPRConfig();
        this.loadUserNMIKeysAll();
        this.loadUserNetSuitAll();
        this.loadHolidayList((new Date()).getFullYear());
        this.patchCurrentYear();

        this._wizardService.getEvolveCSSiteURLAsync(this.encryptedUser)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    if (result.statusCode === 0) {
                        this.simpleResponse = UtilityService.clone(result);
                        if (this.simpleResponse) {
                            this.site = this.simpleResponse.messageString;
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });

        this.checkListConfig = {
            theme: 'dragNDrop',
            hideResetBtn: false,
            hideSelectBtn: false,
            maxSize: 10,
            uploadAPI: {
                url: this.site + 'api/CheckList/ConfigCheckListPost/',

                headers: {
                },
            },
            formatsAllowed: '.pdf',
            multiple: false,
            replaceTexts: {
                selectFileBtn: 'Select File',
                resetBtn: 'Reset',
                uploadBtn: 'Upload File',
                dragNDropBox: 'Drag and Drop your image here',
                attachPinBtn: 'Attach Files...',
                afterUploadMsg_success: 'Successfully Uploaded!',
                afterUploadMsg_error: 'Upload Failed!',
            }
        };
        this.fetchCheckList();
        this.getMySoSite();
    }

    getMySoSite() {
        this._wizardService.getSiteAsync(this.encryptedUser)
            .then(res => {
                if (res)
                    this.simpleResponse = UtilityService.clone(res);
                if (this.simpleResponse) {
                    this.mySOSite = this.simpleResponse.messageString;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }
    async loadYear() {
        //this.yearList = []
        //for (var i = 2020; i < (new Date()).getFullYear() + 2; i++) {
        //    this.yearList.push({ value: i });
        //}
        await this._configMasterService.getHolidayYear(this.encryptedUser)
            .then(async (result: HolidayYear[]) => {
                if (result) {
                    this.yearList = UtilityService.clone(result);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }
    patchCurrentYear() {
        this.configMasterForm.patchValue({
            holidayYear: (new Date()).getFullYear()
        });
    }
    changeYear(event) {
        if (Number(event) < (new Date()).getFullYear())
            this.isPreYear = false;
        else
            this.isPreYear = true;
        this.configMasterForm.patchValue({
            holidayDate: '',
            holidayName: ''
        });
        this.btnAdd = "Add";
        this.hldId = 0;
        this.loadHolidayList(event);
    }
    showUploadCheckList() {
        this.showUploadCheckListFlg = !this.showUploadCheckListFlg;
    }

    checkListUpload(env) {

        this.fetchCheckList();

    }

    private fetchCheckList(): void {

        this._checkListService.getConfigCheckList(this.encryptedUser)
            .subscribe(
                (result: ConfigCheckListImagesResponse) => {
                    this.globalCheckListResponse = result.listConfigImages;
                    this.configCheckListImagesResponse = result;

                    this.checkList = Object.assign([], this.globalCheckListResponse);
                    this.globalCheckListResponse = null;

                },
                error => {
                    console.error(error);
                    this.checkList = null;
                },
                () => {
                }
            );
    }

    openCheckListPDF(response) {
        const linkSource: string = 'data:application/pdf;base64,' + response.Media;
        const downloadLink = document.createElement("a");
        const fileName = response.FileName;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    ngAfterViewChecked() {
        if (!this.changeTemplateEvent) {
            this.populateMergeTemplateddl();
        }
    }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            verticalPosition: 'top',
            horizontalPosition: 'right',
            duration: 5000,
        });
    }

    private async loadDocumentTypeConfigData() {
        await this._documentService.getGetDocumentTypeConfigAsync(this.encryptedUser)
            .then(async (result: DocumentTypeResponse) => {
                if (result) {
                    if (result.statusCode == 0) {
                        this.docTypelst = UtilityService.clone(result.documentTypeList);
                        this.docTemplateList = UtilityService.clone(result.documentTemplateList);
                        this.currentUser = UtilityService.clone(result.currentUser);
                        //const ELEMENT_DOCUMENT_TEMPLATE: DocType[] = !this.isPatentPlusUser ? this.docTypelst.filter(rows => rows.mailMergeTemplateID > 0) :
                        //    this.docTypelst.filter(rows => rows.isActivePatentPlus);
                        const ELEMENT_DOCUMENT_TEMPLATE: DocType[] = this.docTypelst.filter(rows => rows.mailMergeTemplateID > 0 || rows.isActivePatentPlus);
                           
                        //const ELEMENT_DOCUMENT_TEMPLATE: DocType[] = this.docTypelst;
                        this.datasourceTemplate = new MatTableDataSource(ELEMENT_DOCUMENT_TEMPLATE);
                        this.datasourceTemplate.sort = this.sortTemplate;
                    } else {
                        this._utilityService.handleError(result.statusCode, result.errorMsg);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadUserNMIKeysAll() {
        await this._configMasterService.getUserNMIKeysAllAsync(this.encryptedUser)
            .then(async (result: UserNMIKeysResponse) => {
                if (result) {
                    if (result.statusCode == 0) {
                        this.userNMIKeysResponse = UtilityService.clone(result);
                        this.userNMIKeyslst = UtilityService.clone(this.userNMIKeysResponse.userNMIKeysDetails);

                        this.currentUser = UtilityService.clone(result.currentUser);
                        //const ELEMENT_USER_NMI_KEYS: UserNMIKeys[] = this.userNMIKeyslst.filter(rows => this.isPatentPlusUser ? rows.isPatentPlusUser == 1 : rows.isPatentPlusUser == 0 && !rows.userName.includes("patentplus"));
                        const ELEMENT_USER_NMI_KEYS: UserNMIKeys[] = this.userNMIKeyslst;
                        this.userNMIKeysdataSource = new MatTableDataSource(ELEMENT_USER_NMI_KEYS);
                        this.userNMIKeysdataSource.sort = this.sortNMI;
                        //this.userNMIKeysdataSource.paginator = this.paginator;
                    } else {
                        this._utilityService.handleError(result.statusCode, result.errorMsg);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadUserNetSuitAll() {
        await this._configMasterService.getUserNetSuitAllAsync(this.encryptedUser)
            .then(async (result: UserNetSuitResponse) => {
                if (result) {
                    if (result.statusCode == 0) {
                        this.userNetSuitResponse = UtilityService.clone(result);
                        this.userNetSuitlst = UtilityService.clone(this.userNetSuitResponse.userNetSuitDetails);

                        this.currentUser = UtilityService.clone(result.currentUser);
                        //const ELEMENT_USER_NetSuit: UserNetSuit[] = this.userNetSuitlst.filter(rows => this.isPatentPlusUser ? rows.isPatentPlusUser == 1 : rows.isPatentPlusUser == 0 && !rows.userName.includes("patentplus"));
                        const ELEMENT_USER_NetSuit: UserNetSuit[] = this.userNetSuitlst;
                        this.userNetSuitdataSource = new MatTableDataSource(ELEMENT_USER_NetSuit);
                        this.userNetSuitdataSource.sort = this.sortNETSUIT;
                        //this.userNMIKeysdataSource.paginator = this.paginator;
                    } else {
                        this._utilityService.handleError(result.statusCode, result.errorMsg);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }
    private async loadHolidayList(year: number) {
        await this._documentService.getHolidayListByYear(year, this.encryptedUser)
            .then(async (result: Holiday[]) => {
                if (result) {
                    this.holidaylst = UtilityService.clone(result);
                    const ELEMENT_USER_Holiday: Holiday[] = this.holidaylst;
                    this.holiDayListdataSource = new MatTableDataSource(ELEMENT_USER_Holiday);
                    this.holiDayListdataSource.sort = this.sortHoliday;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadAPRConfig() {
        await this._billingService.getAPRConfigAsync(this.encryptedUser)
            .then(async (result: APRConfigResponse) => {
                if (result) {
                    if (result.statusCode == 0) {
                        this.aprConfigList = UtilityService.clone(result.aprConfigList);
                        //const ELEMENT_APR_CONFIG: APRConfig[] = this.aprConfigList.filter(rows => this.isPatentPlusUser ? rows.productDescription.startsWith("Plus") : !rows.productDescription.startsWith("Plus"));
                        const ELEMENT_APR_CONFIG: APRConfig[] = this.aprConfigList;
                        this.aprDatasource = new MatTableDataSource(ELEMENT_APR_CONFIG);
                        let today = new Date();
                        this.showShortSpan = (isNullOrUndefined(this.aprConfigList[0].dtEnd)) || (new Date(this.aprConfigList[0].dtEnd).setHours(0, 0, 0, 0) >= today.setHours(0, 0, 0, 0)) ? true : false;
                        this.dtAPRStart = this.aprConfigList[0].dtStart;
                        this.dtAPREnd = this.aprConfigList[0].dtEnd;
                        this.aprDatasource.sort = this.sortAPR;
                    } else {
                        this._utilityService.handleError(result.statusCode, result.errorMsg);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async getUPNSInvoiceAsync(id: number, usprice = 0, canprice = 0, ausprice = 0, ukprice = 0) {
        this.nsIvoiceResponse = { id: id, internalId: 0, item: '', description: '', uSPrice: usprice, cANPrice: canprice, aUSPrice: ausprice, clpUserId: this.clpUserId, uKPrice: ukprice, isPatentPlus: this.isPatentPlusUser }
        await this._configMasterService.getUPNSInvoiceAsync(this.encryptedUser, this.nsIvoiceResponse)
            .then(async (result: NSIvoice[]) => {
                if (result) {
                    this.NSIvoicelst = UtilityService.clone(result);
                    //const ELEMENT_USER_NSInvoice: NSIvoice[] = this.NSIvoicelst.filter(rows => this.isPatentPlusUser ? rows.isPatentPlus : !rows.isPatentPlus);
                    const ELEMENT_USER_NSInvoice: NSIvoice[] = this.NSIvoicelst;
                    this.IvForm = this.fb.group({
                        IvRows: this.fb.array(ELEMENT_USER_NSInvoice.map(val => this.fb.group({
                            Id: new FormControl(val.id),
                            InternalId: new FormControl(val.internalId),
                            Item: new FormControl(val.item),
                            Description: new FormControl(val.description),
                            USPrice: new FormControl(val.uSPrice),
                            CANPrice: new FormControl(val.cANPrice),
                            AUSPrice: new FormControl(val.aUSPrice),
                            UKPrice: new FormControl(val.uKPrice),
                            actions: new FormControl('existingRecord'),
                            isEditable: new FormControl(true),

                        })
                        ))
                    });
                    this.NSInvoiseListdataSource = new MatTableDataSource((this.IvForm.get('IvRows') as FormArray).controls);
                    this.NSInvoiseListdataSource.sort = this.sortNSI;
                    const filterPredicate = this.dataSource.filterPredicate;
                    this.NSInvoiseListdataSource.filterPredicate = (data: AbstractControl, filter) => {
                        return filterPredicate.call(this.dataSource, data.value, filter);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    EditSVO(IVFormElement, i) {
        IVFormElement.get('IvRows').at(i).get('isEditable').patchValue(false);
        // this.isEditableNew = true;

    }

    SaveVO(IVFormElement, i) {
        if (IVFormElement.get('IvRows').at(i).get('USPrice').value == '' || IVFormElement.get('IvRows').at(i).get('CANPrice').value == '' || IVFormElement.get('IvRows').at(i).get('AUSPrice').value == '' || IVFormElement.get('IvRows').at(i).get('UKPrice').value == '') {
            this.openSnackBar("Please enter valid price.", "")
        }
        else {
            this.getUPNSInvoiceAsync(IVFormElement.get('IvRows').at(i).get('Id').value, IVFormElement.get('IvRows').at(i).get('USPrice').value, IVFormElement.get('IvRows').at(i).get('CANPrice').value, IVFormElement.get('IvRows').at(i).get('AUSPrice').value, IVFormElement.get('IvRows').at(i).get('UKPrice').value);
            IVFormElement.get('IvRows').at(i).get('isEditable').patchValue(true);
            this.openSnackBar("Price save successfully.", "")
        }
    }

    CancelSVO(IVFormElement, i) {
        IVFormElement.get('IvRows').at(i).get('isEditable').patchValue(true);
    }

    private prepareContractTemplateConfigForm(): FormGroup {
        return this.fb.group({
            doctTypeList: this.fb.array([this.fb.group({
                documentTypeId: '',
                mailMergeId: ''
            })])
        });
    }

    editRow(id: number) {
        this.editRowID = id;
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    applyFilterTemplateConfiguration(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.datasourceTemplate.filter = filterValue.trim().toLowerCase();
    }

    applyFilterAPRConfig(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.aprDatasource.filter = filterValue.trim().toLowerCase();
    }

    private async loadPPSOPrice() {
        await this._configMasterService.getPPSOPriceAsync(this.encryptedUser)
            .then(async (result: PPSOPriceResponse) => {
                if (result) {
                    if (result.statusCode == 0) {
                        this.ppsoPriceResponse = UtilityService.clone(result);
                        this.ppsoPrice = UtilityService.clone(this.ppsoPriceResponse.ppsoPriceDetails);
                        this.currentUser = UtilityService.clone(result.currentUser);
                        //const ELEMENT_PPSO_PRICE: PPSOPrice[] = this.ppsoPrice.filter(rows => this.isPatentPlusUser ? rows.productCode == "PP" : rows.productCode != "PP");
                        const ELEMENT_PPSO_PRICE: PPSOPrice[] = this.ppsoPrice;
                        this.dataSource = new MatTableDataSource(ELEMENT_PPSO_PRICE);
                        this.dataSource.paginator = this.paginator;
                        this.dataSource.sort = this.sort;
                    } else {
                        this._utilityService.handleError(result.statusCode, result.errorMsg);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async loadConfigMaster() {
        this._route.paramMap.subscribe(async params => {
            if (params.has('clpuserid')) {
                this.clpUserId = +params.get('clpuserid');
            }
        });

        await this._configMasterService.getConfigMasterAsync(this.encryptedUser)
            .then(async (result: ConfigMasterResponse) => {
                if (result) {
                    if (result.statusCode == 0) {

                        this.configMasterResponse = UtilityService.clone(result);
                        this.configMaster = UtilityService.clone(this.configMasterResponse.configMaster);
                        this.currentUser = UtilityService.clone(result.currentUser);
                        this.configMaster[0].updatedBy = this.clpUserId;
                        this.copyDataObjectToFormValues();
                    } else {
                        this._utilityService.handleError(result.statusCode, result.errorMsg);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    public async saveConfigMaster() {
        this.copyFormValuesToDataObject()
        if (this.configMaster.length > 0) {
            this.configMasterResponse.configMaster = this.configMaster;
            await this._configMasterService.ConfigMaster_UpdateAsync(this.encryptedUser, this.configMasterResponse)
                .then(result => {
                    if (result) {
                        if (result.statusCode == 0) {
                            this.configMasterResponse = UtilityService.clone(result);
                            this.currentUser = UtilityService.clone(result.currentUser);
                            this.configMaster = this.configMasterResponse.configMaster;
                            this.copyDataObjectToFormValues();
                            this._utilityService.showAlertMsg("Contract Configuration", "The Contract Configuration has been saved successfully.");
                        } else {
                            this._utilityService.handleError(result.statusCode, result.errorMsg);
                        }
                    }
                }).catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    private copyDataObjectToFormValues() {
        this.configMasterForm.patchValue({
            isPromotions: (this.configMaster[0].itemValue == 'true'),
            totalCustomers: this.configMaster[1].itemValue || 0,
            ndTotalCustomers: this.configMaster[7].itemValue || 0,
            firstPASRR: this.isPatentPlusUser ? this.configMaster[12].itemValue : this.configMaster[9].itemValue || 0,
            lawyerReferralCost: this.configMaster[11].itemValue || 0,
        });
    }

    private copyFormValuesToDataObject() {
        if (this.configMaster.length > 0) {
            this.configMaster[0].itemValue = this.configMasterForm.controls.isPromotions.value;
            this.configMaster[1].itemValue = this.configMasterForm.controls.totalCustomers.value;
            this.configMaster[7].itemValue = this.configMasterForm.controls.ndTotalCustomers.value;
            if (this.isPatentPlusUser)
                this.configMaster[12].itemValue = this.configMasterForm.controls.firstPASRR.value;
            else
                this.configMaster[9].itemValue = this.configMasterForm.controls.firstPASRR.value;
            this.configMaster[11].itemValue = this.configMasterForm.controls.lawyerReferralCost.value;
        }
    }

    private async updatePrice(id: number) {

        const pid = "PPSOPrice_" + id;
        const updatedPrice = $("#" + pid).val();
        this.selectedppso = this.ppsoPriceResponse.ppsoPriceDetails.filter(i => i.id == id)[0];
        const oldPrice = this.selectedppso.paramVal;
        const msg = "The Service Price was updated from $" + oldPrice + " to $" + updatedPrice + " successfully.";
        await this._configMasterService.PPSOPriceUpdateAsync(this.encryptedUser, id, updatedPrice, this.clpUserId.toString())
            .then(result => {
                if (result) {
                    if (result.statusCode == 0) {
                        this.editRowID = -1;
                        this.loadPPSOPrice();
                        this._utilityService.showAlertMsg("Service Price - (" + this.selectedppso.paramCode + ")", msg);
                    } else {
                        this._utilityService.handleError(result.statusCode, result.errorMsg);
                    }
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    highlight(row) {
        this.highlightedRows = [];
        this.highlightedRows.push(row);
        this.editRowID = row.id;
    }

    applyUserNMIFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.userNMIKeysdataSource.filter = filterValue.trim().toLowerCase();
    }

    applyUserNetSuitFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.userNetSuitdataSource.filter = filterValue.trim().toLowerCase();
    }

    applyHolidayFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.holiDayListdataSource.filter = filterValue.trim().toLowerCase();
    }

    applyNsInvoiceFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.NSInvoiseListdataSource.filter = filterValue.trim().toLowerCase();
    }

    editUserNMIKeyRow(clpUserId: number) {
        this.editRowIDUserNMIKeys = clpUserId;
    }

    editUserNetSuitRow(Id: number) {
        this.editRowIDUserNetSuit = Id;
    }

    private async updateUserNMIKeys(clpUserId: number) {

        const uid = "UserNMIKeys_" + clpUserId;
        const updatedNMIKey = $("#" + uid).val();

        var selectedUserNMIKeys = this.userNMIKeyslst.filter(i => i.clpUserId == clpUserId)[0];
        if (selectedUserNMIKeys) {
            selectedUserNMIKeys.nmiKey = updatedNMIKey;
        }
        this.selectedUserNMIKeys = selectedUserNMIKeys;

        const msg = "The NMI API key was updated successfully.";
        await this._configMasterService.userNMIKeys_UpdateAsync(this.encryptedUser, selectedUserNMIKeys)
            .then(result => {
                if (result) {
                    if (result) {
                        this.editRowIDUserNMIKeys = -1;
                        this.loadUserNMIKeysAll();
                        this._utilityService.showAlertMsg("User name - (" + this.selectedUserNMIKeys.userName + ")", msg);
                    } else {
                        this._utilityService.handleError(result.clpUserId, result.userName);
                    }
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async updateUserNetSuit(Id: number, clpUserId: number) {

        const uid = "UserNetSuit_" + Id;
        const updatedNetSuit = $("#" + uid).val();
        if (updatedNetSuit === '' || updatedNetSuit === '0') {
            this._utilityService.showAlertMsg("", "Please enter netsuite id.");
            return;
        }
        var selectedUserNetSuit = this.userNetSuitlst.filter(i => i.id == Id)[0];
        if (selectedUserNetSuit) {
            selectedUserNetSuit.internalId = updatedNetSuit;
            selectedUserNetSuit.clpUserId = clpUserId;
        }
        this.selectedUserNetSuit = selectedUserNetSuit;

        const msg = "The Internal Id was updated successfully.";
        await this._configMasterService.userNetSuit_UpdateAsync(this.encryptedUser, selectedUserNetSuit)
            .then(result => {
                if (result) {
                    if (result) {
                        this.editRowIDUserNetSuit = -1;
                        this.loadUserNetSuitAll();
                        this._utilityService.showAlertMsg("User name - (" + this.selectedUserNetSuit.userName + ")", msg);
                    } else {
                        this._utilityService.handleError(result.clpUserId, result.userName);
                    }
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    highlightUserNMIKeys(row) {
        if (!this.isNMICancel) {
            this.highlightedUserNMIKeysRows = [];
            this.highlightedUserNMIKeysRows.push(row);
            this.editRowIDUserNMIKeys = row.clpUserId;
        }
        else {
            this.editRowIDUserNMIKeys = -1;
            this.isNMICancel = false;
        }
    }

    highlightUserNetSuit(row) {
        if (!this.isNetSuitCancel) {
            this.highlightedUserNetSuitRows = [];
            this.highlightedUserNetSuitRows.push(row);
            this.editRowIDUserNetSuit = row.id;
        }
        else {
            this.editRowIDUserNetSuit = -1;
            this.isNetSuitCancel = false;
        }
    }

    resetNMIGrid() {
        this.isNMICancel = true;
    }

    resetNetSuitGrid() {
        this.isNetSuitCancel = true;
    }

    saveAllTemplates() {
        this.changeTemplateEvent = false;
        this.updatedDocTypelst = [];


        this.docTypelst.forEach(val => this.updatedDocTypelst.push(Object.assign({}, val)));

        this.updatedDocTypelst.forEach(i => {
            const ddlMailmergeID = "mergeTemplate_" + i.documentTypeID;
            let mailMergeID: number = $("#" + ddlMailmergeID).val();

            if (mailMergeID != i.mailMergeTemplateID && mailMergeID != null) {

                i.mailMergeTemplateID = + mailMergeID;
            }
            else {
                i.documentTypeID = -1;
            }
        });
        this.updatedDocTypelst = this.updatedDocTypelst.filter(i => i.documentTypeID != -1);
        this.saveTemaplates();
    }

    async saveTemaplates() {
        await this._documentService.saveDocumentTypeAsync(this.updatedDocTypelst, this.encryptedUser, this.clpUserId, this.isPatentPlusUser ? "Plus" : "Normal")
            .then(async (result: DocumentTypeResponse) => {
                if (result) {
                    if (result.statusCode == 0) {
                        this.docTypelst = UtilityService.clone(result.documentTypeList);
                        this.docTemplateList = UtilityService.clone(result.documentTemplateList);
                        this.currentUser = UtilityService.clone(result.currentUser);
                        //const ELEMENT_DOCUMENT_TEMPLATE: DocType[] = !this.isPatentPlusUser ? this.docTypelst.filter(rows => rows.mailMergeTemplateID > 0) :
                        //    this.docTypelst.filter(rows => rows.isActivePatentPlus);
                        const ELEMENT_DOCUMENT_TEMPLATE: DocType[] = this.docTypelst;
                        this.datasourceTemplate = new MatTableDataSource(ELEMENT_DOCUMENT_TEMPLATE);
                        this.openSnackBar("The Contract Template Information was saved successfully.", "");
                    } else {
                        this._utilityService.handleError(result.statusCode, result.errorMsg);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    changeTemplate(mergeTempID: number) {
        this.isTemplateDirty = true;
        var template = this.docTypelst.filter(i => i.mailMergeTemplateID == mergeTempID && i.documentTypeID != this.selectedDocumentTypeId)[0];
        this.changeTemplateEvent = true;
        if (template) {
            var dialogResult = this._utilityService.showConfirmMsg("Document Template Configuration", "<b>" + template.mailMergeTemplateName + "</b> is already assigned to <b>" + template.documentTypeName + "</b>. <br />Do you want to proceed?");
            dialogResult.subscribe(result => {
                if (!result) {
                    this.populateMergeTemplateddl();

                }
                //  else { this.isTemplateDirty = true; }
            }
            );
        }
    }

    rowSelectionContractTemplate(row) {
        this.selectedDocumentTypeId = row.documentTypeID;
        if (this.mySOSite) {
            if (this.isPatentPlusUser)
                this.siteURL = this.mySOSite + '/marketing/mailmergetemplate.aspx?mmtid=' + row.patentPlusMailMergeTemplateID;
            else
                this.siteURL = this.mySOSite + '/marketing/mailmergetemplate.aspx?mmtid=' + row.mailMergeTemplateID;
        }
        window.open(this.siteURL, '_blank');
    }

    populateMergeTemplateddl() {
        if (this.docTypelst) {
            this.docTypelst.forEach(i => {
                const ddlMailmergeID = "mergeTemplate_" + i.documentTypeID;
                if (this.isPatentPlusUser)
                    $("#" + ddlMailmergeID).val(i.patentPlusMailMergeTemplateID);
                else
                    $("#" + ddlMailmergeID).val(i.mailMergeTemplateID);
            });
        }
    }

    allowNumeric(e) {
        if (e.ctrlKey || e.altKey) {
            e.preventDefault();
        } else {
            var key = e.keyCode;
            if (key != 8 && key != 0 && (key < 48 || key > 57)) {
                e.preventDefault();
            }
        }
    }

    public async saveHoliday(id) {
        if (this.configMasterForm.controls.holidayDate.value === '') {
            this._utilityService.showAlertMsg("Holiday Date", "Please select valid date!");
            return;
        }
        else if (this.configMasterForm.controls.holidayName.value === '') {
            this._utilityService.showAlertMsg("Holiday Name", "Please enter holiday name!");
            return;
        }

        await this.copyHolidayDataObjectToFormValues(id)
        if (!isNullOrUndefined(this.holidayResponse)) {
            await this._configMasterService.holiday_CreateAsync(this.encryptedUser, this.holidayResponse)
                .then(result => {
                    if (result) {
                        if (result.status == 3) {
                            this._utilityService.showAlertMsg("Holiday", "The Holiday already exist.");
                        }
                        else if (result.status == 1) {
                            this._utilityService.showAlertMsg("Holiday Name", "The Holiday has been saved successfully.");
                            this.loadYear();
                            var currentDate = formatDate(this.holidayResponse.dtHoliday, 'MM/dd/yyyy', 'en-US');
                            this.configMasterForm.patchValue({
                                holidayYear: currentDate.substr(currentDate.length - 4)
                            });
                            this.configMasterForm.patchValue({
                                holidayDate: '',
                                holidayName: ''
                            });
                            this.btnAdd = "Add";
                            this.hldId = 0;
                            this.loadHolidayList(this.configMasterForm.controls.holidayYear.value);
                        }
                        else if (result.status == 2) {
                            this._utilityService.showAlertMsg("Holiday Name", "The Holiday has been updated successfully.");
                            this.loadYear();
                            var currentDate = formatDate(this.holidayResponse.dtHoliday, 'MM/dd/yyyy', 'en-US');
                            this.configMasterForm.patchValue({
                                holidayYear: currentDate.substr(currentDate.length - 4)
                            });
                            this.configMasterForm.patchValue({
                                holidayDate: '',
                                holidayName: ''
                            });
                            this.btnAdd = "Add";
                            this.hldId = 0;
                            this.loadHolidayList(this.configMasterForm.controls.holidayYear.value);
                        }
                        else if (result.status == 4) {
                            this._utilityService.showAlertMsg("Holiday Name", "The Holiday deleted.");
                            this.hldId = 0;

                        }
                        else {
                            this._utilityService.handleError(result.status, result.holidayName);
                        }
                    }
                }).catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    private copyHolidayDataObjectToFormValues(hid: number) {
        this.holidayResponse = { id: hid, dtHoliday: formatDate(this.configMasterForm.controls.holidayDate.value, 'MM/dd/yyyy', 'en-US'), holidayName: this.configMasterForm.controls.holidayName.value, userId: this.clpUserId, status: 0, action: 'U' }
    }

    updateHoliday(id, holidate, holidayName, action) {
        var hdday = formatDate(holidate, 'MM/dd/yyyy', 'en-US');
        this.configMasterForm.patchValue({
            holidayDate: hdday,
            holidayName: holidayName
        });
        this.btnAdd = "Update";
        this.hldId = id;

    }
    getMMDDYYYY(date) {
        var today = new Date(date);
        var dd = today.getDate();
        var mm = today.getMonth();
        var yyyy = today.getFullYear();
        return mm + '/' + dd + '/' + yyyy;
    }

    async deleteHoliday(id, action) {
        $('#modalDeleteHoliday').modal('show');
        this.delId = id;
    }

    async deleteConfirmation(val) {
        if (val == 'Yes') {

            var currentDate = '01/01/2019';
            this.holidayResponse = { id: this.delId, dtHoliday: currentDate, holidayName: '', userId: 0, status: 0, action: 'D' }
            if (!isNullOrUndefined(this.holidayResponse)) {
                await this._configMasterService.holiday_CreateAsync(this.encryptedUser, this.holidayResponse)
                    .then(result => {
                        if (result) {
                            if (result.status == 4) {
                                $('#modalDeleteHoliday').modal('hide');
                                this.openSnackBar("Holiday deleted successfully.", "")
                                this.loadHolidayList(this.configMasterForm.controls.holidayYear.value);

                            }
                            else {
                                $('#modalDeleteHoliday').modal('hide');
                                this._utilityService.handleError(result.status, result.holidayName);
                            }
                        }
                    }).catch((err: HttpErrorResponse) => {
                        this._utilityService.handleErrorResponse(err);
                    });
            }
        }
        else
            $('#modalDeleteHoliday').modal('hide');
    }

    saveNewAPR() {
        $('#modalAPRConfig').modal('show');
    }

    changeAPR() {
        this.isAPRDirty = true;
    }

    toggleAprEnd() {
        this.aprEnd.toggle();
        this.minAPREndDate = this.configMasterForm.controls.aprStartDate.value;
    }

    aprConfirmation(val) {
        if (val == 'Yes') {
            this.updatedAPRConfigList = [];
            this.updatedAPRConfigList = this.aprConfigList;
            this.updatedAPRConfigList.forEach(i => {
                if (($("#newAPR_" + i.configId).val() != '') && !isNullOrUndefined($("#newAPR_" + i.configId).val()))
                    i.newRates = +$("#newAPR_" + i.configId).val();
                i.dtStart = this.configMasterForm.controls.aprStartDate.value;
                i.dtEnd = this.configMasterForm.controls.aprEndDate.value;
            });
            this._billingService.saveAPRConfigAsync(this.updatedAPRConfigList, this.encryptedUser, this.clpUserId)
                .then(async (result: APRConfigResponse) => {
                    if (result) {
                        if (result.statusCode == 0) {
                            this.loadAPRConfig();
                            this.isAPRDirty = false;
                            $('#modalAPRConfig').modal('hide');
                            this.openSnackBar("New Rates was saved successfully.", "");
                        } else {
                            this._utilityService.handleError(result.statusCode, result.errorMsg);
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
        else
            $('#modalAPRConfig').modal('hide');
        this.configMasterForm.patchValue({
            aprStartDate: '',
            aprEndDate: ''
        });
    }
}
